<template lang="pug">
  .document-list-section
    .document-lists(v-if="documentContainsValues({ type: name })")
      .bespoke-documents(v-if="documentContainsValues({ type: name, is_template: false })")
        h4.title Bespoke Documents
        Thumbnail(v-for="filteredDoc in filteredDocumentList({ type: name, is_template: false })" v-bind:key="filteredDoc.id" :doc="filteredDoc" :userPremium="userPremium()")
      .free-documents(v-if="documentContainsValues({ type: name, is_template: true, requires_premium: false })")
        h4.title Free Documents
        Thumbnail(v-for="filteredDoc in filteredDocumentList({ type: name, requires_premium: false, is_template: true })" v-bind:key="filteredDoc.id" :userPremium="userPremium()" :doc="filteredDoc")
      .premium-documents(v-if="documentContainsValues({ type: name, is_template: true, requires_premium: true })")
        h4.title Premium Documents
        Thumbnail(v-for="filteredDoc in filteredDocumentList({ type: name, requires_premium: true, is_template: true })" v-bind:key="filteredDoc.id" :doc="filteredDoc" :userPremium="userPremium()")
</template>

<script>
  import Thumbnail from '@/components/documents/Thumbnail'

  export default {
    props: ['data','name'],
    components: { 
      Thumbnail
    },
    methods: {
      documentContainsValues: function(objectChecks, string) {
        var HAS_TYPE = false;
        const THE_KEYS = Object.keys(objectChecks);

        for(var i = 0; i < this.data.length; i++) {
          let KEYS_VALID = true;

          THE_KEYS.forEach(KEY => {
            if (this.data[i][KEY] != objectChecks[KEY]) {
              KEYS_VALID = false;
            }
          })

          HAS_TYPE = KEYS_VALID;

          if(KEYS_VALID == true)
            break;
        }
        return HAS_TYPE;
      },
      filteredDocumentList: function(filter) {
        return this.data.filter(SINGLE_DOCUMENT => {
          let VALIDITY = true;
          Object.keys(filter).forEach(filter_key => {
            if(SINGLE_DOCUMENT[filter_key] != filter[filter_key]) {
              VALIDITY = false;
            }
          })
          if(VALIDITY === true)
            return true;

          return false;
        })
      },
      userPremium: function() {
        if(this.$store.getters.user.premium == true)
          return true;
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>